<template>
  <div>
    <v-container
      class="mt-n3"
      fluid
      grid-list-lg
    >
      <v-row
        column
        wrap
      >
        <v-col>
          <v-row wrap>
            <v-col md="8">
              <cart-products
                :prop-allow-scanning="!showPaymentDialog"
                :prop-allow-hotkeys="allowHotkeys"
                @cart-blurred="isCartBlurred = $event"
              />

            </v-col>
            <v-col md="4">
              <cart-summary
                ref="cartSummary"
                @paying="togglePaymentDialog"
                @cart-blurred="isCartBlurred = $event"
              />
            </v-col>
          </v-row>
        </v-col>

        <!-- Payment Component -->
        <v-dialog
          v-if="receipt"
          v-model="showPaymentDialog"
          :max-width="receipt.status === RECEIPT_PENDING ? 1200 : 500"
          eager
          no-click-animation
          persistent
        >
          <cart-payment
            v-if="showPaymentDialog"
            :show-completion-countdown="showCompletionCountdown"
            @closed="showPaymentDialog = false"
          />
        </v-dialog>

        <!-- Dialog whether register is still open from previous day -->
        <v-dialog
          v-model="showRegisterShouldBeClosedDialog"
          max-width="500"
          no-click-animation
          @keydown.esc="showRegisterShouldBeClosedDialog = false"
        >
          <v-card v-if="showRegisterShouldBeClosedDialog">
            <v-card-text class="pt-6">
              <v-alert
                class="text-center mb-4"
                color="primary"
                icon="fal fa-exclamation-square"
                outlined
                prominent
                text
              >
                {{ `${$t('This cash register has already been open for more than a day.')} ${$t('We recommend to close the cash register before registering the next sale.')}` }}
              </v-alert>
              <v-list class="super-dense">
                <v-list-item>
                  <v-list-item-content>{{ $t('Store') }}</v-list-item-content>
                  <v-list-item-content class="align-end">{{ _.get(cashRegister, 'store.name') }}</v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>{{ $t('Cash Register') }}</v-list-item-content>
                  <v-list-item-content class="align-end">{{ _.get(cashRegister, 'description') }}</v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>{{ $t('Closure #') }}</v-list-item-content>
                  <v-list-item-content class="align-end">{{ _.get(cashRegister, 'openedReport.nr') }}</v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>{{ $t('Opened At') }}</v-list-item-content>
                  <v-list-item-content class="align-end">{{ _.get(cashRegister, 'openedReport.created') | moment("D MMMM YYYY HH:mm") }}</v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
            <v-divider />
            <v-card-actions>
              <v-spacer />
              <v-btn
                :to="{ name: 'CashRegistersOpenClose' }"
                class="font-weight-bold"
                color="primary"
                text
              >{{ $t('Close Register') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </v-container>
    <cart-bottom-sheet />
  </div>
</template>

<script>
import CartProducts from '@/components/checkout/CartProducts'
import CartSummary from '@/components/checkout/CartSummary'
import CartPayment from '@/components/checkout/CartPayment'
import CartBottomSheet from '@/components/checkout/CartBottomSheet'
import { RECEIPT_PENDING } from '@/utils/statuses/receipt'
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'Cart',

  components: {
    CartProducts,
    CartSummary,
    CartPayment,
    CartBottomSheet
  },

  data: () => ({
    isCartBlurred: false,
    showPaymentDialog: false,
    showRegisterShouldBeClosedDialog: false,
    RECEIPT_PENDING
  }),

  computed: {
    ...mapGetters(['cashRegister']),
    ...mapGetters('RECEIPT', ['itemCount']),
    ...mapState('RECEIPT', ['receipt']),
    allowHotkeys () {
      if (this.showPaymentDialog) return false
      if (this.showRegisterShouldBeClosedDialog) return false
      if (this.isCartBlurred) return false
      return true
    },
    registerShouldBeClosed () {
      if (this.cashRegister && this.cashRegister.openedReport) {
        const startedDate = moment(this.cashRegister.openedReport.created).format('YYYY-MM-DD')
        const now = moment().format('YYYY-MM-DD')
        return startedDate !== now
      }
      return false
    },
    showCompletionCountdown () {
      // Cart must have products and there is no outstanding balance
      return this.showPaymentDialog && !!this.itemCount && this.receipt.outstandingBalance <= 0
    }
  },

  created () {
    if (this.registerShouldBeClosed) {
      this.toggleRegisterShouldBeClosedDialog()
    }
  },

  methods: {
    togglePaymentDialog () {
      this.showPaymentDialog = !this.showPaymentDialog
    },
    toggleRegisterShouldBeClosedDialog () {
      this.showRegisterShouldBeClosedDialog = !this.showRegisterShouldBeClosedDialog
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Checkout/Cart.vue